export const ADVANCED_TAB_NAME = 'advanced';
